import { loadKindsRegistry } from '@/lib/nostr-kinds-registry'
import { TKindGroup } from '@/types/window'

async function describeKind(kind: number): Promise<string> {
  const data = await loadKindsRegistry()
  const description = data?.kinds?.[`${kind}`]?.description?.trim()
  if (description) return description
  return `Kind ${kind}`
}

export async function getKindFilterOptions(): Promise<TKindGroup[]> {
  const { feedKinds, kindGroups } = window.hallway.universe

  if (!kindGroups || kindGroups.length === 0) {
    // default lazy case, just use the feed kinds
    return Promise.all(
      feedKinds.map(async (kind) => ({
        label: await describeKind(kind),
        kinds: [kind]
      }))
    )
  }

  // when both are specified
  const grouped = new Set<number>()
  const options: TKindGroup[] = []

  // do first the specifically listed grouped ones
  for (const group of kindGroups) {
    const label = group.label ?? (await describeKind(group.kinds[0]))
    options.push({
      label,
      kinds: [...group.kinds],
      disabled: group.disabled
    })
    for (const k of group.kinds) grouped.add(k)
  }

  // then do the remaining kinds
  for (const k of feedKinds) {
    if (!grouped.has(k)) {
      options.push({
        label: await describeKind(k),
        kinds: [k]
      })
    }
  }

  return options
}

export function getDefaultShowKinds(): number[] {
  const { feedKinds, kindGroups } = window.hallway.universe

  if (!kindGroups || kindGroups.length === 0) {
    return [...feedKinds]
  }

  const grouped = new Set<number>()
  const result: number[] = []

  for (const group of kindGroups) {
    if (!group.disabled) {
      for (const k of group.kinds) result.push(k)
    }
    for (const k of group.kinds) grouped.add(k)
  }

  for (const k of feedKinds) {
    if (!grouped.has(k)) result.push(k)
  }

  return result
}
